<template>
  <a
    :id="id"
    :class="isActive ? 'nav-categories-link--active' : null"
    class="nav-categories-link font-heading font-bold lg:font-body"
    @click="hasOverlay ? processLinkClick(id) : null"
    v-html="linkText"
  />
</template>

<script>
import {mapActions, mapState} from 'vuex';

export default {
  name: 'NavCategoriesLink',
  props: {
    /**
     * All of the overlay data associated with this category link in JSON format.
     */
    jsonData: {
      type: Array,
      default: null,
    },
    /**
     * The uid of the link. This is used to set the "activeLink" in VueX.
     */
    id: {
      type: String,
      default: null,
    },
    /**
     * The text of the link
     */
    linkText: {
      type: String,
      default: null,
    },
    /**
     * When true, links without products in this category's overlay will be hidden
     */
    hideLinksWithoutProducts: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('global', ['isCompactView']),
    ...mapState('navigation', ['activeLink']),
    isActive() {
      return this.id === this.activeLink;
    },
    hasOverlay() {
      return Boolean(this.jsonData);
    },
  },
  mounted() {
    if (this.hasOverlay) {
      this.optimizeOverlayData({
        link: this.id,
        linkText: this.linkText,
        jsonData: this.jsonData,
        hideLinksWithoutProducts: this.hideLinksWithoutProducts,
      });
    }
  },
  methods: {
    ...mapActions('navigation', ['optimizeOverlayData', 'setDefaultActiveTab', 'updateActiveLink']),
    processLinkClick(id) {
      if (this.isCompactView) {
        this.updateActiveLink(id);
      } else {
        this.updateActiveLink(id);
        this.setDefaultActiveTab();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.nav-categories-link {
  display: block;
  margin: 0.75rem 0;
  color: var(--white) !important; // Needed until #primary-navigation & it's associated styles can be removed in phase 2
  font-size: 1.875rem;
  line-height: 1;

  &--active {
    text-decoration: underline;
  }

  @include breakpoint(large) {
    margin: 0;
    font-size: 0.875rem;
  }
}
</style>
